// extracted by mini-css-extract-plugin
module.exports = {"Portfolios":"Portfolios_Portfolios__b04Pv","error":"Portfolios_error__3M2et","spindindust":"Portfolios_spindindust__CZnvL"};